<template>
  <div
    class="d-flex font-weight-medium title-widget"
    :class="{
      'text-h5 text-sm-h4 text-md-h2 text-lg-h1': !small,
      'text-subtitle-2 text-sm-h6 text-md-h4 text-lg-h3': small,
    }"
  >
    <div class="d-flex flex-column justify-center">
      <span v-if="title" class="font-secondary">
        {{ title }}
      </span>

      <span
        v-if="subtitle"
        class="text-sm-overline font-weight-bold subtitle mt-1"
      >
        {{ subtitle }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
  },
};
</script>
<style lang="scss" scoped>
.subtitle {
  line-height: normal !important;
  @media (max-width: 600px) {
    font-size: 12px !important;
    font-weight: 500 !important;
  }
}
</style>
